function Icon({ size = "20", color = "#000000" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 2C5.59 2 2 5.59 2 10C2 14.41 5.59 18 10 18C14.41 18 18 14.41 18 10C18 5.59 14.41 2 10 2ZM10 17C6.14 17 3 13.86 3 10C3 6.14 6.14 3 10 3C13.86 3 17 6.14 17 10C17 13.86 13.86 17 10 17ZM11 9H14.41V11H11V14.41H9V11H5.59V9H9V5.59H11V9Z"
        fill={color}
      />
    </svg>
  );
}

export default Icon;
